import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import IconBack from "../resources/icons/icons_back_36.png";
import IconForward from "../resources/icons/icons_forward_36.png";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

const MdlOldDueCollectionConfirmation = ({
  netPayableAmount,
  action_close,
  action_submit,
}) => {
  const [show, setShow] = useState(true);
  const [amount, setAmount] = useState(0);
  const [TRANSACTION_DATE, setTRANSACTION_DATE] = useState("");
  const [TRANSACTION_DATE2, setTRANSACTION_DATE2] = useState("");
  const [day_count, setDay_count] = useState(0);
  const [PaymentRemark, setPaymentRemark] = useState("");
  const [PAYMENT_MODE, setPAYMENT_MODE] = useState("CASH");

  useEffect(() => {
    setAmount(netPayableAmount);
    getCurrentDate();
  }, [netPayableAmount]);

  const getCurrentDate = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();

    const date_dd_mm_yyyy = dd + "-" + mm + "-" + yyyy;
    const date_yyyy_mm_dd = yyyy + "-" + mm + "-" + dd;

    setTRANSACTION_DATE(date_dd_mm_yyyy);
    setTRANSACTION_DATE2(date_yyyy_mm_dd);
  };

  const nextDate = () => {
    const newDayCount = day_count + 1;
    setDay_count(newDayCount);
    const date = new Date();
    date.setDate(date.getDate() + newDayCount);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    const date_dd_mm_yyyy = dd + "-" + mm + "-" + yyyy;
    const date_yyyy_mm_dd = yyyy + "-" + mm + "-" + dd;

    setTRANSACTION_DATE(date_dd_mm_yyyy);
    setTRANSACTION_DATE2(date_yyyy_mm_dd);
  };

  const previousDate = () => {
    const newDayCount = day_count - 1;
    setDay_count(newDayCount);
    const date = new Date();
    date.setDate(date.getDate() + newDayCount);

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    const date_dd_mm_yyyy = dd + "-" + mm + "-" + yyyy;
    const date_yyyy_mm_dd = yyyy + "-" + mm + "-" + dd;

    setTRANSACTION_DATE(date_dd_mm_yyyy);
    setTRANSACTION_DATE2(date_yyyy_mm_dd);
  };

  const handleChangePaymentMode = (event) => {
    setPAYMENT_MODE(event.target.value);
  };

  const handleClose = () => {
    setShow(false);
    action_close();
  };

  const submitRequest = () => {
    setShow(false);
    action_submit(TRANSACTION_DATE2, PAYMENT_MODE, PaymentRemark);
  };

  return (
    <div>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        style={{ opacity: 1 }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        size="lg"
        dialogClassName="old-due-confirmation-modal"
      >
        <Modal.Header
          closeButton
          style={{
            background: `linear-gradient(135deg, ${COLORS.primary_color_shade7 || "#01579B"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`,
            color: COLORS.white,
            borderTopLeftRadius: "20px",
            borderTopRightRadius: "20px",
            borderBottom: "none",
            padding: "14px 18px",
          }}
        >
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={{
              fontWeight: 700,
              fontSize: "18px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <i className="fa fa-check-circle" style={{ fontSize: "20px" }} />
            Old Due Collection Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "16px 18px", background: COLORS.grey1 || "#F5F5F5" }}>
          {/* Transaction Amount - Modern Card */}
          <div
            style={{
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#039BE5"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`,
              borderRadius: "20px",
              padding: "16px 20px",
              marginBottom: "12px",
              boxShadow: `0 4px 16px ${COLORS.primary_color_shade3}40`,
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "13px",
                color: "rgba(255, 255, 255, 0.9)",
                marginBottom: "6px",
                fontWeight: 500,
              }}
            >
              Transaction Amount
            </div>
            <div
              style={{
                fontSize: "32px",
                fontWeight: 700,
                color: COLORS.white,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "6px",
              }}
            >
              <i className="fa fa-rupee-sign" style={{ fontSize: "24px" }} />
              {amount.toLocaleString()}
            </div>
          </div>

          {/* Collection Date - Modern Card */}
          <div
            style={{
              background: COLORS.white,
              border: `2px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
              borderRadius: "20px",
              padding: "14px 16px",
              marginBottom: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: COLORS.black8 || "#333333",
                marginBottom: "12px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <i
                className="fa fa-calendar"
                style={{ color: COLORS.primary_color_shade6, fontSize: "16px" }}
              />
              Collection Date
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "12px",
              }}
            >
              <button
                onClick={previousDate}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "16px",
                  border: `2px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                  background: COLORS.primary_color_shade1 || "#B3E5FC",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  padding: 0,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = COLORS.primary_color_shade3 || "#4FC3F7";
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = COLORS.primary_color_shade1 || "#B3E5FC";
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <img src={IconBack} alt="Previous" style={{ width: "20px", height: "20px" }} />
              </button>
              <div
                style={{
                  flex: 1,
                  textAlign: "center",
                  padding: "10px 14px",
                  background: COLORS.grey1 || "#F5F5F5",
                  borderRadius: "16px",
                  border: `1px solid ${COLORS.grey3 || "#E0E0E0"}`,
                }}
              >
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: 700,
                    color: COLORS.black8 || "#333333",
                  }}
                >
                  {TRANSACTION_DATE}
                </div>
              </div>
              <button
                onClick={nextDate}
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "16px",
                  border: `2px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                  background: COLORS.primary_color_shade1 || "#B3E5FC",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  padding: 0,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = COLORS.primary_color_shade3 || "#4FC3F7";
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = COLORS.primary_color_shade1 || "#B3E5FC";
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <img src={IconForward} alt="Next" style={{ width: "20px", height: "20px" }} />
              </button>
            </div>
          </div>

          {/* Payment Mode - Modern Card */}
          <div
            style={{
              background: COLORS.white,
              border: `2px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
              borderRadius: "20px",
              padding: "14px 16px",
              marginBottom: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: COLORS.black8 || "#333333",
                marginBottom: "12px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <i
                className="fa fa-credit-card"
                style={{ color: COLORS.primary_color_shade6, fontSize: "16px" }}
              />
              Payment Mode
            </div>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <RadioGroup
                aria-label="position"
                name="radio_css_inline"
                id="inlineCssRadio"
                value={PAYMENT_MODE}
                onChange={handleChangePaymentMode}
                row={true}
                defaultValue="CASH"
              >
                <FormControlLabel
                  value="CASH"
                  control={<Radio color="primary" />}
                  label="Pay in Cash"
                  labelPlacement="end"
                  defaultChecked="true"
                  style={{
                    marginRight: "16px",
                    padding: "6px 12px",
                    borderRadius: "12px",
                    background:
                      PAYMENT_MODE === "CASH"
                        ? COLORS.primary_color_shade1 || "#B3E5FC"
                        : "transparent",
                    transition: "all 0.3s ease",
                  }}
                />
                <FormControlLabel
                  value="CHEQUE"
                  control={<Radio color="primary" />}
                  label="Pay by Cheque"
                  labelPlacement="end"
                  style={{
                    marginRight: "16px",
                    padding: "6px 12px",
                    borderRadius: "12px",
                    background:
                      PAYMENT_MODE === "CHEQUE"
                        ? COLORS.primary_color_shade1 || "#B3E5FC"
                        : "transparent",
                    transition: "all 0.3s ease",
                  }}
                />
                <FormControlLabel
                  value="ONLINE"
                  control={<Radio color="primary" />}
                  label="Pay Online"
                  labelPlacement="end"
                  style={{
                    padding: "6px 12px",
                    borderRadius: "12px",
                    background:
                      PAYMENT_MODE === "ONLINE"
                        ? COLORS.primary_color_shade1 || "#B3E5FC"
                        : "transparent",
                    transition: "all 0.3s ease",
                  }}
                />
              </RadioGroup>
            </div>
          </div>

          {/* Payment Remark - Modern Card */}
          <div
            style={{
              background: COLORS.white,
              border: `2px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
              borderRadius: "20px",
              padding: "14px 16px",
              marginBottom: "0",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
            }}
          >
            <div
              style={{
                fontSize: "14px",
                fontWeight: 600,
                color: COLORS.black8 || "#333333",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <i
                className="fa fa-comment"
                style={{ color: COLORS.primary_color_shade6, fontSize: "16px" }}
              />
              Payment Remark
            </div>
            <input
              type="text"
              required
              id="PaymentRemark"
              placeholder="Enter payment remark or description"
              value={PaymentRemark}
              onChange={(e) => setPaymentRemark(e.target.value)}
              style={{
                width: "100%",
                padding: "12px 14px",
                fontSize: "15px",
                border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
                borderRadius: "16px",
                transition: "all 0.3s ease",
                outline: "none",
                boxSizing: "border-box",
                background: COLORS.white,
              }}
              onFocus={(e) => {
                e.currentTarget.style.borderColor = COLORS.primary_color_shade6 || "#039BE5";
                e.currentTarget.style.boxShadow = `0 0 0 3px ${COLORS.primary_color_shade1}40`;
              }}
              onBlur={(e) => {
                e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
                e.currentTarget.style.boxShadow = "none";
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: `1px solid ${COLORS.grey3 || "#E0E0E0"}`,
            padding: "12px 18px",
            background: COLORS.grey1 || "#F5F5F5",
            borderBottomLeftRadius: "20px",
            borderBottomRightRadius: "20px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
          }}
        >
          <Button
            variant="secondary"
            onClick={handleClose}
            style={{
              padding: "10px 20px",
              borderRadius: "16px",
              border: `2px solid ${COLORS.grey3 || "#E0E0E0"}`,
              background: COLORS.white,
              color: COLORS.black8 || "#333333",
              fontWeight: 600,
              fontSize: "14px",
              transition: "all 0.3s ease",
              flex: "0 0 auto",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = COLORS.grey2 || "#EEEEEE";
              e.currentTarget.style.borderColor = COLORS.grey4 || "#BDBDBD";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = COLORS.white;
              e.currentTarget.style.borderColor = COLORS.grey3 || "#E0E0E0";
            }}
          >
            Cancel
          </Button>
          <button
            type="button"
            onClick={submitRequest}
            style={{
              padding: "10px 24px",
              borderRadius: "16px",
              background: `linear-gradient(135deg, ${COLORS.primary_color_shade6 || "#039BE5"} 0%, ${COLORS.primary_color_shade8 || "#0277BD"} 100%)`,
              border: "none",
              color: COLORS.white,
              fontWeight: 700,
              fontSize: "15px",
              boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}60`,
              transition: "all 0.3s ease",
              flex: "1 1 auto",
              minWidth: "120px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-2px)";
              e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.primary_color_shade4}80`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.primary_color_shade3}60`;
            }}
          >
            <i className="fa fa-check-circle" style={{ marginRight: "6px", fontSize: "14px", color: COLORS.white }} />
            Submit
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MdlOldDueCollectionConfirmation;

